<script>
import { VDivider } from 'vuetify/lib'

export default {
  name: 'EDivider',
  extends: VDivider,
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    size: {
      type: [Number, String],
      default: 0,
    },

    // unsupported props
    inset: Boolean,
  },
  //
  // render(h) {
  //   // WAI-ARIA attributes
  //   let orientation
  //
  //   if (!this.$attrs.role || this.$attrs.role === 'separator') {
  //     orientation = this.vertical ? 'vertical' : 'horizontal'
  //   }
  //
  //   const space = this.vertical ? `0 ${this.size}px` : `${this.size}px 0`
  //
  //   return h('hr', {
  //     class: {
  //       'e-divider': true,
  //       'v-divider': true,
  //       'v-divider--inset': this.inset,
  //       'v-divider--vertical': this.vertical,
  //       ...this.themeClasses,
  //     },
  //     style: {
  //       margin: space,
  //     },
  //     attrs: {
  //       role: 'separator',
  //       'aria-orientation': orientation,
  //       ...this.$attrs,
  //     },
  //     on: this.$listeners,
  //   })
  // },
}
</script>
